import sample_1 from './MBPJeans.jpg';

export const MBPJeansImpressions = {
    sample_1,
};
